import Router from 'vue-router'
Vue.use(Router)


// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


export default new Router({
	mode: 'history',
	base: '/web',

	routes: [
    {
      path: '/',
      redirect:'/haoping'
    },
    {
        path: '/login',
        component: () => import('@/admin/login'),
        mete:{
          title:"注册登录",
        }
    },

    {
    	path: '/haoping',
      component: () => import('@/admin/haoping/index'),
      redirect:'/haoping/haoping',
      children:[
        {
          path: '/haoping/haoping',
          component: () => import('@/admin/haoping/haoping'),
          mete:{
            title:"列表",
          },
        },
        {
          path: '/haoping/haopingdetail',
          component: () => import('@/admin/haoping/haopingdetail'),
          mete:{
            title:"查看详情",
          },
        },
      ]
    },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js